export default __webpack_public_path__ + "static/media/blue-lotus.95004b79.svg";